import { createContext } from 'react';
import { User } from 'referral-types';

type AuthContextType = {
  currentUser?: User;
  isSignedIn: boolean;
  isAdmin: boolean;
  isMember: boolean;
  isInfluencer: boolean;
  setCurrentUser: (user?: User) => void;
  isSavingUser?: boolean;
  clearUserInfo: () => void;
};

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
